import * as React from 'react';
import IconImage from '../../common/IconImage';
import { AppStates } from '../../../reducers/app';
import { connect } from 'react-redux';
import { LineType } from '../../../drawing/types';
import { FreehandPenState } from '../../../reducers/ui/freehandPen';
import { LineStyle } from '../../../reducers/ui/ui';
import { FreehandPenWidth } from '../../../types/freehandPenWidth';
import { Color } from '../../../types/color';
import { getBasePath } from '../../../utils/browser';

interface FreehandPenIconImageProps {
  readonly buttonNumber: number;
  readonly freehandPen: FreehandPenState;
  readonly svgStyle?: React.CSSProperties;
}

const getColorBaseNameString = (color: Color): string => {
  switch (color) {
    case Color.Red:
    case Color.RedTransparent:
      return '_red';
    case Color.Blue:
    case Color.BlueTransparent:
      return '_blue';
    case Color.Yellow:
    case Color.YellowTransparent:
      return '_yellow';
    case Color.Green:
    case Color.GreenTransparent:
      return '_green';
    case Color.Black:
    case Color.BlackTransparent:
      return '_black';
    default:
      return '';
  }
};

const getLineStyleString = (lineStyle: LineStyle): string => {
  switch (lineStyle) {
    case LineStyle.Freehand:
      return '_free';
    case LineStyle.HorizontalAxisAligned:
      return '_flat';
    case LineStyle.VerticalAxisAligned:
      return '_vertical';
  }
};

const getPenWidthString = (width: FreehandPenWidth): string => {
  switch (width) {
    case FreehandPenWidth.one:
      return '_size01';
    case FreehandPenWidth.two:
      return '_size02';
    case FreehandPenWidth.three:
      return '_size03';
    case FreehandPenWidth.four:
      return '_size04';
    case FreehandPenWidth.five:
      return '_size05';
  }
};

const getLineTypeString = (lineType: LineType): string => {
  switch (lineType) {
    case LineType.Solid:
      return '_solid';
    case LineType.Dashed:
      return '_dot';
    default:
      throw new Error('Illegal state.');
  }
};

const getTransparencyString = (color: Color): string => {
  switch (color) {
    case Color.RedTransparent:
    case Color.BlueTransparent:
    case Color.YellowTransparent:
    case Color.GreenTransparent:
    case Color.BlackTransparent:
      return '_transparent';
    default:
      return '';
  }
};

const FreehandPenIconImage: React.SFC<
  FreehandPenIconImageProps
> = (props) => {
  const { buttonNumber, freehandPen, svgStyle } = props;
  const { color, width, lineType, lineStyle } = freehandPen.toolSettings[buttonNumber];

  let iconName = 'dynamic/freehandpen/icon_pen';
  iconName += getColorBaseNameString(color);
  iconName += getLineStyleString(lineStyle);
  iconName += getPenWidthString(width);
  iconName += getLineTypeString(lineType);
  iconName += getTransparencyString(color);

  const baseDir = getBasePath();
  const src = `${baseDir}/images/tool-icons/${iconName}.png`;

  return <IconImage src={src} svgStyle={svgStyle} />;
};

const mapStateToProps = (appStates: AppStates) => {
  return { freehandPen: appStates.ui.freehandPen };
};

export default connect(mapStateToProps)(FreehandPenIconImage);
